import { useQuery } from '@based/sdk/react'
import { useMemo } from 'react'
import { ViewHousingFormModel } from 'functions/app/housing-form/view'

export const usePopularHousingForms = ({
  excludeIds,
}: {
  excludeIds: (string | number)[]
}) => {
  const housingFormsQuery: { data?: ViewHousingFormModel[] } =
    useQuery('list-housing-forms')

  const followerCountQuery = useQuery('count-followers', {
    entityType: 'housingForm',
    entityIds: housingFormsQuery.data?.map((h) => h.id),
  })

  const popularHousingForms = useMemo(() => {
    return (
      (housingFormsQuery.data || [])
        .map((item, index) => ({
          ...item,
          followerCount: followerCountQuery.data?.[index] ?? 0,
        }))
        .sort((a, b) => {
          return b.followerCount - a.followerCount
        })

        .filter((housingForm) => !excludeIds.includes(housingForm.id)) || []
    )
  }, [housingFormsQuery.data, excludeIds, followerCountQuery.data])

  return {
    popularHousingForms,
  }
}
